import { PdfPageDetails } from "@/Common/Components/Pdf/PdfViewer/PdfViewer";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { Person } from "@/Common/Models/Person/Person";
import { DocumentUIState } from "@/Common/Models/UI/Enums";
import { PersonDropdownItem } from "@/Common/Models/UI/Inputs/PersonDropdownItem";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { BatchScanPage } from "@/Documents/Api/Dto/Response/BatchScanPage";
import { DocumentsStore } from "@/Documents/Stores/DocumentsStore";

class CreateDocumentHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Documents.Create_OnAttachClick, this.attachDocument);
        this.RegisterOperation(LocalOperations.Documents.Create_OnCancel, this.onCancelClick);
        this.RegisterOperation(LocalOperations.Documents.Create_Patient_Selection_Change, this.selectPatient);
        this.RegisterOperation(LocalOperations.Documents.Create_Patient_ClearSelection, this.clearSelection);
        this.RegisterOperation(LocalOperations.Documents.Create_Clinician_Selection_Change, this.selectClinician);
        this.RegisterOperation(LocalOperations.Documents.Create_ShowDetails, this.toggleDetailsDisplay);
        this.RegisterOperation(LocalOperations.Documents.Create_OnTodayClick, this.setTodayDateOnDocumentDateSelector);
        this.RegisterOperation(LocalOperations.Documents.Create_OnUrgencyCheckChange, this.changeDocumentUrgency);
        this.RegisterOperation(LocalOperations.Documents.Create_Set_Document_Date, this.setDocumentDate);

        // additional details
        this.RegisterOperation(LocalOperations.Documents.Create_SendingFacilityIdChange, this.facilityIdChange);
        this.RegisterOperation(LocalOperations.Documents.Create_SendingFacilityReportChange, this.reportNumberChange);
        this.RegisterOperation(LocalOperations.Documents.Create_SubClassChange, this.subClassChang);
        this.RegisterOperation(LocalOperations.Documents.Create_AccompanyingSubClassChange, this.accompanyingSubClassChang);
        this.RegisterOperation(LocalOperations.Documents.Create_MnemonicChange, this.mnemonicChange);
        this.RegisterOperation(LocalOperations.Documents.Create_SourceAuthorNameChange, this.sourceAuthorNameChange);
        this.RegisterOperation(LocalOperations.Documents.Create_AuthoringDateChange, this.authroingDateChang);
        this.RegisterOperation(LocalOperations.Documents.Create_ObservationDateChange, this.observationDateChange);
        this.RegisterOperation(LocalOperations.Documents.Create_NoteChange, this.onNoteChange);

        this.RegisterOperation(LocalOperations.Documents.Create_OnSourcesChange, this.sourcesChange);
        this.RegisterOperation(LocalOperations.Documents.Create_OnDescriptionChange, this.descriptionChange);
        this.RegisterOperation(LocalOperations.Documents.Create_HRMStatusChange, this.hrmStatusChange);

        this.RegisterOperation(LocalOperations.Documents.Create_UploadComplete, this.onUploadComplete);
        this.RegisterOperation(LocalOperations.Documents.Create_UploadFailPatientProfile, this.onUploadFailPatientProfile);

        this.RegisterOperation(LocalOperations.Documents.Create_OnFileSelectionChange, this.onFileSelectionChange);

        this.RegisterOperation(LocalOperations.Documents.Create_SiteChange, this.onSiteChanged);
        this.RegisterOperation(LocalOperations.Documents.ToggleRememberClinician, this.toggleRememberClinician);
        this.RegisterOperation(LocalOperations.Documents.ToggleRememberDescription, this.toggleRememberDescription);
        this.RegisterOperation(LocalOperations.Documents.ToggleRememberPatient, this.toggleRememberPatient);
        this.RegisterOperation(LocalOperations.Documents.ToggleRememberSite, this.toggleRememberSite);

        this.RegisterOperation(LocalOperations.Documents.CloseBatchScanPopup, this.closeBatchScanPopup);
        this.RegisterOperation(LocalOperations.Documents.StartANewProjectClick, this.startANewProjectClick);
        this.RegisterOperation(LocalOperations.Documents.StartANewProjectCancelClick, this.startANewProjectCancelClick);
        this.RegisterOperation(LocalOperations.Documents.StartANewProjectContinueClick, this.startANewProjectContinueClick);
        this.RegisterOperation(LocalOperations.Documents.OpenBatchScanPopup, this.openBatchScanPopup);
        this.RegisterOperation(LocalOperations.Documents.FinishBatchScan, this.finishBatchScan);
        this.RegisterOperation(LocalOperations.Documents.closePleaseWaitPopup, this.closePleaseWaitPopup);
        this.RegisterOperation(LocalOperations.Documents.ContinueProjectClick, this.continueProjectClick);
        this.RegisterOperation(LocalOperations.Documents.DeleteFileClick, this.deleteFileClick);
        this.RegisterOperation(LocalOperations.Documents.OnPageClick, this.onPageClick);
        this.RegisterOperation(LocalOperations.Documents.OnEnlargePageClick, this.onEnlargePageClick);
        this.RegisterOperation(LocalOperations.Documents.OnBatchScanAttachClick, this.onBatchScanAttachClick);
        this.RegisterOperation(LocalOperations.Documents.ClearBatchProject, this.clearBatchProject);
        this.RegisterOperation(LocalOperations.Documents.OpenWarningDeletePopup, this.openWarningDeletePopup);
        this.RegisterOperation(LocalOperations.Documents.CloseWarningDeletePopup, this.closeWarningDeletePopup);
        this.RegisterOperation(LocalOperations.Documents.OnRemovePageClick, this.onRemovePageClick);
        this.RegisterOperation(LocalOperations.Documents.OnRotatePage, this.onRotatePage);
        this.RegisterOperation(LocalOperations.Documents.OnCreateNewPatientClick, this.onCreateNewPatientClick);
        this.RegisterOperation(LocalOperations.Documents.CloseCreatePatientPopup, this.closeCreatePatientPopup);
        this.RegisterOperation(LocalOperations.Documents.Save_NewPatient, this.SaveNewPatient);
        this.RegisterOperation(LocalOperations.Documents.RefreshBatchScanning, this.refreshBatchScanning);
        this.RegisterOperation(LocalOperations.Documents.ToggleFileTypeErrorPopup, this.toggleFileTypeErrorPopup);
    }

    private toggleRememberDescription(request: LocalEvent, store: DocumentsStore): void {
        var newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("RememberDescription", !newDoc.get("RememberDescription"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private attachDocument(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        if (newDoc.get("SelectedPatients").size > 0) {
            newDoc = newDoc.set("LockUI", true);
            store.DocumentsModel = store.DocumentsModel.set("BeginUpload", true);

            store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
            store.DocumentActions.CreateNewDocument(newDoc);
        }
    }

    private clearSelection(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc
            .set("SelectedPatients", Immutable.List([]))
            .set("ExternalAttachment", null);

        if (!newDoc.get("RememberClinician"))
            newDoc = newDoc.set("SelectedClinicians", Immutable.List([]));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private selectPatient(request: LocalEvent, store: DocumentsStore): void {
        let patientItem = request.Get<PersonDropdownItem>("value");

        let newDoc = store.DocumentsModel.get("NewDocument");

        let list = newDoc.get("SelectedPatients").toArray();

        function indexOf(id: string, collection: Person[]): number {
            let idx = -1;
            for (let i = 0; i < collection.length; i++) {
                if (id === collection[i].ContactId) {
                    idx = i;
                    break;
                }
            }
            return idx;
        }

        let idx = indexOf(patientItem.Item.ContactId, list);
        if (idx === -1) {
            list.push(patientItem.Item);
        }
        else {
            list.splice(idx, 1);
        }

        newDoc = newDoc.set("SelectedPatients", Immutable.List(list));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private selectClinician(request: LocalEvent, store: DocumentsStore): void {
        let selectedClinician = request.Get<PersonDropdownItem>("value");

        if (selectedClinician == null || selectedClinician.Item == null)
            return;

        let newDocument = store.DocumentsModel.get("NewDocument");
        let responsibleProviders = newDocument.get("SelectedClinicians").toArray();

        responsibleProviders.map(x => x.ContactId).indexOf(selectedClinician.Item.ContactId) > -1
            ? responsibleProviders = responsibleProviders.filter(x => x.ContactId != selectedClinician.Item.ContactId)
            : responsibleProviders.push(selectedClinician.Item);

        newDocument = newDocument.set("SelectedClinicians", Immutable.List<Person>(responsibleProviders));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDocument);
    }

    private toggleDetailsDisplay(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        let t = !newDoc.get("AdditionalDetailsVisible");
        newDoc = newDoc.set("AdditionalDetailsVisible", t);
        if (t) {
            newDoc = newDoc.set("DetailsLinkLabel", cacheStore.GetString("HideDocumentDetailsLabel"));
            newDoc = newDoc.set("DetailsLinkImagePath", rootPath + "../content/images/icons/documents/add_details_open.png");
        }
        else {
            newDoc = newDoc.set("DetailsLinkLabel", cacheStore.GetString("AddDocumentDetailsLabel"));
            newDoc = newDoc.set("DetailsLinkImagePath", rootPath + "../content/images/icons/documents/add_details.png");
        }
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private setTodayDateOnDocumentDateSelector(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("DocumentDate", new Date());
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private changeDocumentUrgency(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        let mDoc = newDoc.get("MedicalDocumentInfo");
        mDoc.Model.IsUrgent = request.Get<boolean>("value");
        newDoc = newDoc.delete("MedicalDocumentInfo");
        newDoc = newDoc.set("MedicalDocumentInfo", mDoc);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private setDocumentDate(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        if (request.Get("value") != null) {
            newDoc = newDoc.set("DocumentDate", request.Get<Date>("value"));
            store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
        }
        else {
            if (store.DocumentsModel.get("NewDocument").get("DocumentDate") != null) {
                let d = new Date(newDoc.get("DocumentDate").toString());
                let ms = d.getMilliseconds() + 1;
                d.setMilliseconds(ms);
                newDoc = newDoc.set("DocumentDate", d);
                store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
            }
        }
    }

    private facilityIdChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("SendingFacilityId", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private reportNumberChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("SendingFacilityReport", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private subClassChang(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("ClassLookupId", request.Get<string>("value_class"));
        newDoc = newDoc.set("SubClassLookupId", request.Get<string>("value_subclass"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private accompanyingSubClassChang(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("AccompanyingSubClass", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private mnemonicChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("AccompanyingMnemonic", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private sourceAuthorNameChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("SourceAuthorName", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private authroingDateChang(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("AuthoringDate", request.Get<Date>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private observationDateChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("ObservationDate", request.Get<Date>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private onNoteChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("Note", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private sourcesChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("Source", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private onSiteChanged(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        let mDoc = newDoc.get("MedicalDocumentInfo");
        mDoc.Model.SiteId = request.Get<string>("value");

        newDoc = newDoc.delete("MedicalDocumentInfo");
        newDoc = newDoc.set("MedicalDocumentInfo", mDoc);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private descriptionChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("Description", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private hrmStatusChange(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("SelectedHRMStatus", request.Get<string>("value"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private onFileSelectionChange(request: LocalEvent, store: DocumentsStore): void {
        const count = request.Get<number>("count");

        const newDoc = store.DocumentsModel.get("NewDocument")
            .set("NumberOfFiles", count);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private onUploadComplete(request: LocalEvent, store: DocumentsStore): void {
        const keepPatient = request.Get<boolean>("keepPatient") ?? false;

        let newDoc = store.DocumentsModel.get("NewDocument");
        const mdoc = newDoc.get("MedicalDocumentInfo");
        mdoc.Model.IsUrgent = false;

        newDoc = newDoc
            .set("LockUI", false)
            .set("MedicalDocumentInfo", mdoc);

        store.DocumentsModel = store.DocumentsModel
            .set("NewDocument", newDoc)
            .set("IsAttachInProcess", false);

        this.clearDocument(store, keepPatient);

        if (store.DocumentsModel.get("IsVisible") === false) {
            store.SaveState();
        }
    }

    private onUploadFailPatientProfile(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("LockUI", false);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    public onCancelClick(request: LocalEvent, store: DocumentsStore): void {
        this.clearDocument(store);
        store.DocumentsModel = store.DocumentsModel
            .set("UIState", DocumentUIState.Search)
            .set("LeftMenuOpen", true);
    }

    public clearFormContent(request: LocalEvent, store: DocumentsStore): void {
        this.clearDocument(store);
    }

    private clearDocument(store: DocumentsStore, keepPatient: boolean = false): void {
        let newDoc = store.DocumentsModel.get("NewDocument");

        store.DocumentsModel = store.DocumentsModel.set("BeginUpload", false);
        newDoc = newDoc.set("NumberOfFiles", 0);
        if (keepPatient !== true && newDoc.get("RememberPatient") !== true && !store.DocumentsModel.get("IsFromPatient")) {
            newDoc = newDoc.set("SelectedPatients", Immutable.List([]));
        }

        // clinicians not removed as per legacy myle
        if (newDoc.get("RememberClinician") === false) {
            newDoc = newDoc.set("SelectedClinicians", Immutable.List([]));
        }

        if (newDoc.get("RememberDescription") === false) {
            newDoc = newDoc.set("Description", "");
        }

        if (newDoc.get("RememberSite") === false) {
            const mdoc = newDoc.get("MedicalDocumentInfo");
            mdoc.Model.SiteId = "";
            newDoc = newDoc.set("MedicalDocumentInfo", mdoc);
        }

        newDoc = newDoc.set("AdditionalDetailsVisible", false);

        newDoc = newDoc
            .set("Note", "")
            .set("DocumentDate", new Date())
            .set("IsUrgent", false)
            .set("SendingFacilityId", "")
            .set("SendingFacilityReport", "")
            .set("AccompanyingSubClass", "")
            .set("AccompanyingMnemonic", "")
            .set("SourceAuthorName", "")
            .set("AuthoringDate", null)
            .set("ObservationDate", null)
            .set("SelectedHRMStatus", newDoc.get("HRMStatusList").get(0).Key)
            .set("HideBatchScanAndAttachButton", false)
            .set("SelectedBatchScanPages", [])
            .set("BatchScanPages", null)
            .set("ListOfImagePath", Immutable.List([]))
            .set("ImageBase64List", Immutable.List([]))
            .set("SelectedPageArray", Immutable.List([]))
            .set("Source", "");

        // store.DocumentsModel = store.DocumentsModel.set("LeftMenuOpen", true);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);

        // least intrusive way to cleanly focus on element on refresh
        window.setTimeout(() => {
            let ev = new LocalEvent(LocalOperations.Misc.Focus);
            ev.AddItem("id", "add_doc_patients");
            MiscDispatcher.dispatch(ev);
        }, 100);
    }

    private closePleaseWaitPopup(request: LocalEvent, store: DocumentsStore): void {
        store.DocumentsModel = store.DocumentsModel
            .set(
                "NewDocument",
                store.DocumentsModel.get("NewDocument")
                    .set("PleaseWaitPopup", false)
            );
        sessionStore.hideGlobalOverlay();
    }

    private continueProjectClick(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");

        newDoc = newDoc.set("PleaseWaitPopup", true);
        newDoc = newDoc.set("BatchScanPopupOpen", false);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);

        store.DocumentActions.GetBatchScanPages();
    }

    private finishBatchScan(request: LocalEvent, store: DocumentsStore): void {
        let batchScanPages = request.Get<BatchScanPage[]>("BatchScanPages");
        let newDoc = store.DocumentsModel.get("NewDocument");

        newDoc = newDoc
            .set("BatchScanPages", batchScanPages)
            .set("PleaseWaitPopup", false)
            .set("HideBatchScanAndAttachButton", true)
            .set("HasBatchScan", true);

        store.DocumentsModel = store.DocumentsModel
            .set("NewDocument", newDoc);

        overlayStore.hideAllOverlays();
    }

    private openBatchScanPopup(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("BatchScanPopupOpen", true);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);

        sessionStore.showGlobalOverlay(true);
    }

    private startANewProjectContinueClick(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("StartNewPojectPopup", false);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
        store.DocumentActions.StartNewBatchPojectClick();

        sessionStore.hideGlobalOverlay();
    }

    private startANewProjectCancelClick(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("StartNewPojectPopup", false);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);

        sessionStore.hideGlobalOverlay();
    }

    private startANewProjectClick(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("BatchScanPopupOpen", false);
        newDoc = newDoc.set("StartNewPojectPopup", true);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private closeBatchScanPopup(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("BatchScanPopupOpen", false);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);

        sessionStore.hideGlobalOverlay();
    }

    private toggleRememberClinician(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("RememberClinician", !newDoc.get("RememberClinician"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private toggleRememberSite(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("RememberSite", !newDoc.get("RememberSite"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private toggleRememberPatient(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("RememberPatient", !newDoc.get("RememberPatient"));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private deleteFileClick(request: LocalEvent, store: DocumentsStore): void {
        let docCreate = store.DocumentsModel.get("NewDocument");
        docCreate = docCreate.set("PleaseWaitPopup", false)
            .set("HideBatchScanAndAttachButton", false)
            .set("DeleteWarningPopup", false)
            .set("BatchScanPages", null)
            .set("SelectedBatchScanPages", [])
            .set("ImageBase64List", Immutable.List([]));

        store.DocumentsModel = store.DocumentsModel.set("LeftMenuOpen", true);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", docCreate);

        store.DocumentActions.StartNewBatchPojectClick();

        sessionStore.hideGlobalOverlay();
    }

    private onPageClick(request: LocalEvent, store: DocumentsStore): void {
        const selectedPages = request.Get<PdfPageDetails[]>("selectedPages");
        let docCreate = store.DocumentsModel.get("NewDocument");
        let value = request.Get<number>("value");
        let imageList = docCreate.get("ImageBase64List").toArray();

        if (imageList && !IsNullOrUndefined(value)) {
            imageList[value].IsChecked = !imageList[value].IsChecked;

            let selectedPagesLegacy = docCreate.get("SelectedPageArray").toArray();
            let totalKb = docCreate.get("SelectedPageTotalKb");

            if (imageList[value].IsChecked) {
                selectedPagesLegacy.push(imageList[value].PageNumber);
                totalKb += imageList[value].PageSizes;
            }
            else if (!imageList[value].IsChecked) {
                selectedPagesLegacy = selectedPagesLegacy.filter(p => p !== imageList[value].PageNumber);
                totalKb -= imageList[value].PageSizes;
            }

            docCreate = docCreate
                .set("SelectedPageArray", Immutable.List(selectedPagesLegacy))
                .set("SelectedPageTotalKb", totalKb);
        }

        docCreate = docCreate
            .set("ImageBase64List", Immutable.List(imageList))
            .set("SelectedBatchScanPages", selectedPages);

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", docCreate);
    }

    private onEnlargePageClick(request: LocalEvent): void {
        const value = request.Get<number>("value");

        const docUrl = apiSettings.buildAppUrl(`api/medicalDocuments/enlargePage/${sessionStore.getCurrentEmployee().ContactId}/${value}`, { auth: true });
        MyleHelper.OpenNewWindow(docUrl);
    }

    private onBatchScanAttachClick(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");

        if (newDoc.get("SelectedPatients").size > 0) {
            newDoc = newDoc.set("LockUI", true);
            store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
            store.DocumentActions.CreateNewDocumentFromBatchScan(newDoc);
        }
    }

    private clearBatchProject(request: LocalEvent, store: DocumentsStore): void {
        if (!store.DocumentsModel?.get("IsAttachInProcess")) {
            let docCreate = store.DocumentsModel.get("NewDocument");

            docCreate = docCreate
                .set("ImageBase64List", Immutable.List([]))
                .set("SelectedPageArray", Immutable.List([]))
                .set("SelectedBatchScanPages", [])
                .set("HideBatchScanAndAttachButton", false);

            store.DocumentsModel = store.DocumentsModel.set("NewDocument", docCreate);
        }
    }

    private refreshBatchScanning(request: LocalEvent, store: DocumentsStore): void {
        if (!store.DocumentsModel?.get("IsAttachInProcess")) {
            let docCreate = store.DocumentsModel.get("NewDocument");
            const ImageBase64List = docCreate?.get("ImageBase64List")?.filter(p => !p.IsChecked) ?? [];

            docCreate = docCreate
                .set("ImageBase64List", Immutable.List(ImageBase64List))
                .set("SelectedPageArray", Immutable.List([]))
                .set("SelectedBatchScanPages", [])
                .set("HideBatchScanAndAttachButton", false);

            store.DocumentsModel = store.DocumentsModel.set("NewDocument", docCreate);
        }
    }

    private openWarningDeletePopup(request: LocalEvent, store: DocumentsStore): void {
        let docCreate = store.DocumentsModel.get("NewDocument");

        docCreate = docCreate.set("DeleteWarningPopup", true);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", docCreate);

        sessionStore.showGlobalOverlay(true);
    }

    private closeWarningDeletePopup(request: LocalEvent, store: DocumentsStore): void {
        let docCreate = store.DocumentsModel.get("NewDocument");

        docCreate = docCreate.set("DeleteWarningPopup", false);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", docCreate);
        sessionStore.hideGlobalOverlay();
    }

    private onRemovePageClick(request: LocalEvent, store: DocumentsStore): void {
        let pageNumber = request.Get<number>("pageNumber");
        store.DocumentActions.onRemoveSingleBatchScan(pageNumber);
    }

    private onRotatePage(request: LocalEvent, store: DocumentsStore): void {
        const pageNumber = request.Get<number>("pageNumber");
        const newOrientation = request.Get<number>("newOrientation");
        store.DocumentActions.onRotatePage(pageNumber, newOrientation);
    }

    private onCreateNewPatientClick(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("ShowCreatePatientPopup", true);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private closeCreatePatientPopup(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");
        newDoc = newDoc.set("ShowCreatePatientPopup", false);
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private SaveNewPatient(request: LocalEvent, store: DocumentsStore): void {
        let patientItem = request.Get<Person>("new_patient");
        let newDoc = store.DocumentsModel.get("NewDocument");
        let list = newDoc.get("SelectedPatients").toArray();

        list.push(patientItem);

        newDoc = newDoc.set("SelectedPatients", Immutable.List(list));
        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }

    private toggleFileTypeErrorPopup(request: LocalEvent, store: DocumentsStore): void {
        let newDoc = store.DocumentsModel.get("NewDocument");

        newDoc = newDoc
            .set("FailUploadModal", !newDoc.get("FailUploadModal"))
            .set("LockUI", !newDoc.get("FailUploadModal"));

        store.DocumentsModel = store.DocumentsModel.set("NewDocument", newDoc);
    }
}

export { CreateDocumentHandler };
